<template>
    <div class="page" style="max-width: 600px">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">Settings</h4>
                </div>
            </div>
        </div>
        <div class="card card-body m-0">
            <div class="form-group row">
                <label class="col-sm-5 col-lg-4 col-form-label">Automatically show vehicles after: </label>
                <div class="col-sm-7 col-lg-8">
                    <input :class="{ 'parsley-error' : form.errors.has('days_in_stock') }"
                           class="form-control"
                           placeholder="Enter days in stock"
                           title="Days in stock"
                           type="number"
                           v-model="form.days_in_stock">
                    <ul :class="{'filled' : form.errors.has('days_in_stock')}"
                        class="parsley-errors-list">
                        <li class="parsley-required">
                            {{ form.errors.get('days_in_stock') }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="text-center mt-3">
                <button :disabled="form.busy"
                        @click="submit()"
                        class="btn btn-primary waves-effect waves-light"
                        type="button">
                    <i class="mdi mdi-content-save"/>
                    Save changes
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Actions from "@/constants/store/actions";

export default {
    data() {
        return {
            form: new Form({
                days_in_stock: null,
            }, {
                days_in_stock: 'required|integer|min:1',
            }),
            company: null,
        }
    },
    mounted() {
        this.company = this.$store.state.user.companies[0];
        this.form = _.extend(this.form, _.pick(this.company, ['days_in_stock']));
    },
    methods: {
        submit() {
            this.form.validate()
                .then(() => {
                    this.$confirm('Are you sure to save changes?', 'Confirm', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'info'
                    }).then(() => {
                        App.putData('/web-api/company/' + this.company.id, this.form)
                            .then(() => {
                                this.$store.dispatch(Actions.refresh_auth_user);
                                this.$notify({
                                    title: 'Success',
                                    message: 'Successfully updated days in stock.',
                                    type: 'success'
                                });
                            })
                    });
                });
        }
    }
}
</script>
